module.exports = __webpack_public_path__ + "img/img_project_content2.e5f378de.svg";